import { type ReactHTML } from 'react'
import {
  type DashFontSize,
  dashFontSizeElementMapping,
} from 'legacy/dash-blocks/foundation/typography'

export const resolveDashTextElementType = (fontSize: DashFontSize): keyof ReactHTML =>
  dashFontSizeElementMapping[fontSize]
